export const isProd = import.meta.env.VITE_APP_ADMIN_ENV === 'production';
